import React, { useEffect } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Checkbox, Input } from '../../../../components/ModalInputs'
import ModalFooter from '../../../../components/ModalFooter/ModalFooter'
import { getLibraryPrivileges } from '../../../../actions/library'
import CustomSelect from '../../../../components/CustomSelect'

export default function TrustedPersonsModal({ data, closeModal, height, addMode, tabType, onSave }) {
  const dispatch = useDispatch()
  const { privileges: privilegesList } = useSelector(state => state.library)

  const isPrivileges = tabType === 'privileges'

  useEffect(() => {
    if (isPrivileges && !privilegesList?.length) dispatch(getLibraryPrivileges())
  }, [isPrivileges]) // eslint-disable-line

  const { values, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: data || {},
    enableReinitialize: true,
    onSubmit: (vals) => {
      if (onSave) onSave(vals)
    }
  })

  const setVal = (name, value) => {
    setFieldValue(name, value)
    if (name === 'privilegecode' && isPrivileges) {
      const found = (privilegesList || []).find(p => (p.code || '').trim() === value)
      if (found) setFieldValue('privilegename', found.name || '')
    }
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      center
      classNames={{ modal: styles.custom }}
    >
      <div className={styles.modalLocal}>
        <h3 className={styles.title}>{isPrivileges ? 'Льгота' : 'Доверенное лицо'}</h3>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsColomn}>

            {!isPrivileges && (
              <>
                <Input
                  label='Фамилия И.О.'
                  name='fio'
                  value={values.fio || ''}
                  onChange={handleChange}
                  style={{ width: '400px' }}
                />
                <Input
                  label='Документ'
                  name='document'
                  value={values.document || ''}
                  onChange={handleChange}
                  style={{ width: '400px' }}
                />
                <Input
                  type='date'
                  label='Срок действия'
                  name='documentdate'
                  value={values.documentdate || ''}
                  onChange={handleChange}
                />
                <Checkbox
                  label='Забирать в каникулы'
                  checked={values.holidays === -1}
                  onChange={(e) => setFieldValue('holidays', e.target.checked ? -1 : 0)}
                  name='holidays'
                />
                <Checkbox
                  label='Сопровождать в отпуск'
                  checked={values.vacation === -1}
                  onChange={(e) => setFieldValue('vacation', e.target.checked ? -1 : 0)}
                  name='vacation'
                />
                <Checkbox
                  label='Без сопровождения'
                  checked={values.withoutsupport === -1}
                  onChange={(e) => setFieldValue('withoutsupport', e.target.checked ? -1 : 0)}
                  name='withoutsupport'
                />
              </>
            )}

            {isPrivileges && (
              <>
                {console.log('privilegesList::: ', privilegesList)}
                <CustomSelect
                  title='Льгота'
                  valuesName='privilegecode'
                  value={(values.privilegecode || '').trim()}
                  options={(privilegesList || []).map(p => ({
                    name: p.name,
                    value: (p.code || '').trim()
                  }))}
                  setFieldValue={setVal}
                  withoutAll
                />
                <Input
                  label='Наименование льготы'
                  name='privilegename'
                  value={values.privilegename || ''}
                  onChange={handleChange}
                />
                <Input
                  label='Дополнительные сведения'
                  name='additional'
                  value={values.additional || ''}
                  onChange={handleChange}
                  style={{ width: '400px' }}
                />
              </>
            )}

          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
    </Modal>
  )
}
